<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Activity, Ticket, Smartphone, Calendar } from 'lucide-vue-next'
import DashboardKpiCard from './DashboardKpiCard.vue'
import type { DashboardData } from './dashboard-process'

const props = defineProps<{
    data: DashboardData
}>()

const { t, n } = useI18n()

const deltaText = computed(() => {
    const d = props.data.validationsDelta
    if (d === null) return null
    if (Math.abs(d) < 0.5) return t('dashboard.kpi.deltaFlat')
    const percent = Math.round(Math.abs(d))
    return d > 0
        ? t('dashboard.kpi.deltaUp', { percent })
        : t('dashboard.kpi.deltaDown', { percent })
})
</script>

<template>
    <div class="mb-6">
    <div class="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">{{ t('dashboard.kpi.sectionLabel') }}</div>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <DashboardKpiCard
            v-if="data.validationsLast24h !== null"
            :label="t('dashboard.kpi.validations24h')"
            :value="n(data.validationsLast24h)"
            :sub="deltaText"
            :sparkline-values="data.hourlyValidations ?? []"
            :icon="Activity"
        />
        <DashboardKpiCard
            v-if="data.ticketsTotal !== null"
            :label="t('dashboard.kpi.tickets')"
            :value="`${n(data.ticketsUsed ?? 0)} / ${n(data.ticketsTotal)}`"
            :sub="data.ticketsUsagePercent !== null ? `${data.ticketsUsagePercent} %` : null"
            :icon="Ticket"
        />
        <DashboardKpiCard
            v-if="data.activeDevicesCount !== null"
            :label="t('dashboard.kpi.devicesOnline')"
            :value="`${data.activeDevicesCount} / ${data.totalDevicesCount ?? '?'}`"
            :icon="Smartphone"
        />
        <DashboardKpiCard
            v-if="data.upcomingEventsCount !== null"
            :label="t('dashboard.kpi.upcomingEvents')"
            :value="n(data.upcomingEventsCount)"
            :icon="Calendar"
        />
    </div>
    </div>
</template>
